import styled from "styled-components";

export const ServicesContainer = styled.div`
    min-height: 800px;
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image:linear-gradient(#ffffff, #f5f5f5, #ffffff);
    padding: 50px 0;

    @media screen and (max-width: 768px) {
        min-height: 1100px;
    }

    @media screen and (max-width: 480px) {
        min-height: 1300px;
    }

`

export const ServicesWrapper = styled.div`
    max-width: 1000px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    grid-gap: 16px;
    padding: 20px 50px;

    @media screen and (max-width: 1000px) {
        grid-template-columns: 1fr 1fr;
        padding: 20px 50px;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        //padding: 0 20px;
        padding: 20px 50px;
    }

`
export const ServicesWrapper1    = styled.div`
    max-width: 700px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    grid-gap: 16px;
    padding: 10px 30px;

    @media screen and (max-width: 1000px) {
        grid-template-columns: 1fr 1fr;
        padding: 20px 50px;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        //padding: 0 20px;
        padding: 20px 50px;
    }

`
export const ServicesCard = styled.div`
    // background-image:linear-gradient(90deg,#c2e59c,#64b3f9,#fcb035);
    background-image:linear-gradient(90deg, #c1a162, #7d868c, #89b3d2);
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    max-height: 550px;
    padding: 30px;
    box-shadow: 0 1px 3px rgba(189, 0, 0, 0.2);
    transition: all 0.2s ease-in-out;

    &:hover {
        transform: scale(1.2);
    }

`

export const ServicesIcon = styled.img`
    max-height: 300px;
    width: 100%;
    margin-bottom: 20px;
    
`

export const ServicesIconc = styled.img`
    max-height: 300px;
    width: 100%;
    margin-bottom: 50px;
    
`

export const ServicesIcon1 = styled.img`
    max-height: 360px;
    width: 100%;
    margin-bottom: 40px;
    
`
export const ServicesIcon2 = styled.img`
    max-height: 250px;
    width: 200px;
    margin-bottom: 20px;
    
`

export const ServicesIcon3 = styled.img`
    max-height: 300px;
    width: 220px;
    margin-bottom: 20px;
    
`
export const ServicesH1 = styled.h1`
    font-size: 2.5rem;
    color: #bd7c1a;
    margin-bottom: 6px;

    @media screen and (max-width: 480px) {
        font-size: 2rem;
    }

`

export const ServicesH2 = styled.h2`
    font-size: 1.1rem;
    margin-bottom: 10px;
    font-weight: 900;
    
`

export const ServicesP = styled.p`
    font-size: 1rem;
    margin-top: 10px;
    text-align: justify;
    // justify-content: center;

`
